import { createContext } from 'react';
import { CreateAccountManuallyStepsContextProps } from './CreateAccountManuallySteps.types';

export const CreateAccountManuallyStepsContext = createContext<CreateAccountManuallyStepsContextProps>(
  {} as CreateAccountManuallyStepsContextProps
);
